<template>
  <li :ref="`ItemParent${keyParent}`" :class="{ active: keyParent === activeIndexParent }">
    <a v-if="isHasChild" href="" @click.prevent="selectParent">{{ parent.name }}</a>
    <router-link
      v-else
      :to="`/category/${parent['my_soco_sql_id']}/${$options.filters.slug(parent.name)}`"
      @click.native="updateStateIndex"
      >{{ parent.name }}</router-link
    >
  </li>
</template>

<script>
/* eslint-disable vue/require-prop-types */
export default {
  name: 'item-parent',
  props: {
    grandParent: {
      required: true,
    },
    keyParent: {
      required: true,
    },
    parent: {
      required: true,
    },
  },
  data() {
    return {
      isSelectedParentWithNoHaveChild: false,
    };
  },
  computed: {
    activeIndexParent() {
      return this.$store.state.header.mobile.activeIndexParent;
    },
    activeIndexChild() {
      return this.$store.state.header.mobile.activeIndexChild;
    },
    isHasChild() {
      return this.$SO.size(this.parent.children);
    },
  },
  methods: {
    selectParent() {
      this.$SO('#listParentMobile li').removeClass('active');
      if (this.activeIndexParent !== this.keyParent) {
        this.$store.commit('updateActiveIndexChild', -1);
      }
      this.$store.commit('updateActiveIndexParent', this.keyParent);
    },
    updateStateIndex() {
      this.$SO(this.$refs.listAllParent).removeClass('active');
      this.$store.commit('updateActiveIndexParent', -1);
      this.$store.commit('updateActiveIndexChild', -1);
      this.$SO(this.$refs[`ItemParent${this.keyParent}`]).addClass('active');
      this.$store.commit('updatePrimaryMenuMobile', '');
    },
  },
};
</script>
